// Cuddo product page: gallery, quantity, checkout
(() => {
  // When the Shopify store is live, paste the product's checkout or cart link here,
  // for example "https://your-store.myshopify.com/cart/VARIANT_ID:" (the quantity is added to the end).
  const CHECKOUT_URL = '';

  /* gallery */
  const slides = [...document.querySelectorAll('#stage img')];
  const thumbs = [...document.querySelectorAll('#thumbs button')];
  let current = 0;
  function show(i) {
    if (i === current) return;
    slides[current].classList.remove('on');
    thumbs[current].setAttribute('aria-current', 'false');
    current = (i + slides.length) % slides.length;
    slides[current].classList.add('on');
    thumbs[current].setAttribute('aria-current', 'true');
  }
  thumbs.forEach((b, i) => b.addEventListener('click', () => show(i)));
  document.getElementById('thumbs').addEventListener('keydown', e => {
    if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
      e.preventDefault();
      show(current + (e.key === 'ArrowRight' ? 1 : -1));
      thumbs[current].focus();
    }
  });
  // swipe on the big photo
  const stage = document.getElementById('stage');
  let sx = null;
  stage.addEventListener('pointerdown', e => { sx = e.clientX; });
  stage.addEventListener('pointerup', e => {
    if (sx === null) return;
    const dx = e.clientX - sx;
    if (Math.abs(dx) > 40) show(current + (dx < 0 ? 1 : -1));
    sx = null;
  });

  /* quantity */
  const out = document.getElementById('qty');
  let qty = 1;
  const qtyInput = document.getElementById('qtyInput');
  const setQty = n => {
    qty = Math.min(9, Math.max(1, n));
    out.textContent = qty;
    if (qtyInput) qtyInput.value = qty;
  };
  document.getElementById('minus').addEventListener('click', () => setQty(qty - 1));
  document.getElementById('plus').addEventListener('click', () => setQty(qty + 1));

  /* checkout: goes to Shopify once CHECKOUT_URL is set; until then it says so plainly */
  const notice = document.getElementById('notice');
  // In the Shopify theme the button submits the real product form, so there is nothing to do here.
  if (document.getElementById('cuddoForm')) return setupSticky();
  document.getElementById('checkout').addEventListener('click', () => {
    if (CHECKOUT_URL) {
      location.href = CHECKOUT_URL.endsWith(':') ? CHECKOUT_URL + qty : CHECKOUT_URL;
      return;
    }
    notice.textContent = 'Checkout opens soon. This button will take you straight to secure checkout.';
    notice.classList.add('show');
  });

  setupSticky();

  /* sticky buy bar on phones, once the main button scrolls away */
  function setupSticky() {
    const bar = document.getElementById('stickyBuy');
    const main = document.getElementById('checkout');
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([e]) => {
        const show = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('show', show);
        bar.setAttribute('aria-hidden', String(!show));
        bar.querySelector('a').tabIndex = show ? 0 : -1;
      }).observe(main);
    }
  }
})();
